import { createFileRoute, Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";
import kimbRu from "@/assets/kimb-ru.png.asset.json";
import cimbEn from "@/assets/cimb-en.png.asset.json";

export const Route = createFileRoute("/$lang/about")({
  head: ({ params }) => ({
    meta: [
      { title: "About — MadCaptains" },
      { name: "description", content: "Mission, editorial principles, and a word from the founder." },
      { property: "og:title", content: "About — MadCaptains" },
      { property: "og:description", content: "Mission, editorial principles, and a word from the founder." },
      { property: "og:url", content: `/${params.lang}/about` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/about` }],
  }),
  component: AboutPage,
});

function AboutPage() {
  const { lang, t } = useI18n();
  return (
    <PageShell
      eyebrow={lang === "ru" ? "Манифест" : "Manifesto"}
      title={t.page_about_h1}
    >
      <div className="space-y-10 text-[1.02rem] leading-[1.75]">
        <section>
          <h2 className="font-display text-2xl">{t.about_mission_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.about_mission_what}</p>
          <p
            className="mt-5 text-justify rounded-sm border-l-2 p-4 font-display text-lg italic"
            style={{
              borderColor: "var(--amber)",
              background: "color-mix(in oklab, var(--amber) 6%, transparent)",
            }}
          >
            {t.about_mission_quote}
          </p>
          <p className="mt-3 text-justify text-sm text-muted-foreground">
            {t.about_mission_records}
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.about_roots_h2}</h2>
          <img
            src={lang === "ru" ? kimbRu.url : cimbEn.url}
            alt=""
            className="mt-5 w-[200px]"
          />
          <p className="mt-3 text-justify text-muted-foreground">{t.about_roots_p1}</p>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.about_how_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.about_how_p1}</p>
          <p className="mt-3 text-justify text-muted-foreground">{t.about_how_p2}</p>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.about_founder_h2}</h2>
          <p className="mt-3 text-justify">
            <Link
              to="/$lang"
              params={{ lang }}
              className="underline-offset-4 hover:underline"
              style={{ color: "var(--amber)" }}
            >
              {t.about_founder_link}
            </Link>
          </p>
        </section>
      </div>
    </PageShell>
  );
}
